import { OnInit, OnDestroy, Optional, Inject } from '@angular/core';
import { Component } from '@angular/core';
import { IContextService } from '@pershing/pershing-core';
import { DomainContext } from '@pershing/pershing-core';
import { Subscription } from 'rxjs';
import { PershingTranslationService } from '@pershing/pershing-core';
import { NxiRestService } from '../../services/NXI-Rest.service';
import { NxiWidgetParamsService } from '../../services/NXI-WidgetParams.service';
import { NxiContextUtils } from '@pershing/nxi-common';

declare let dojoApp: any;

@Component({
    selector: 'dojo-trading-overview',
    templateUrl: './dojo-trading-overview.component.html'
})
export class DojoTradingOverviewComponent implements OnInit, OnDestroy {
    inputValue: string = '';
    domain: string = '';
    subs: Subscription;
    acctRef: any;
    appSettings: any;
    constructor(private contextService: IContextService,
                private translationService: PershingTranslationService,
                private nxiRestService: NxiRestService,
                private nxiWidgetParamsService: NxiWidgetParamsService,
                @Optional() @Inject('AppSettings') appSettings: any) {
        this.appSettings = appSettings;            
        this.translationService.addTranslationFolder('@pershing/nxi-ng-portfolio', 'node_modules/@pershing/nxi-ng-portfolio/lib');
    }

    prevAcctRef: string;
    isComponentLoaded: boolean;

    ngOnInit() {
        this.subs = this.contextService.selectedDomainContext$.subscribe((domainContext: DomainContext<any>) => {
            let contextValue = NxiContextUtils.getContextFromDomainValue(domainContext);
            this.inputValue = contextValue.inputValue;
            this.acctRef = contextValue.hashValue;
            if (!this.isComponentLoaded || (this.prevAcctRef !== this.acctRef)) {
                this.isComponentLoaded = true;
                  this.getTradingWidgetParams();
                 this.prevAcctRef = this.acctRef;
            }
        });
    }

    renderDojoWidget(tradingWidgetParams: any) {
        if (dojoApp) {
            // pass necessary parameters to render dojo widgets
            tradingWidgetParams.nxiRestBaseUrl = this.nxiRestService.serviceUrl;
            dojoApp.renderTradingOverview(tradingWidgetParams);
        }
    }

    ngOnDestroy(): void {
        if (this.subs) {
            this.subs.unsubscribe();
        }
        if (dojoApp) {
            dojoApp.destroyWidget('tradingOverview');
        }
    }

    getTradingWidgetParams() {
        if (this.inputValue !== '' && this.acctRef) {
            this.nxiWidgetParamsService.getWidgetParams(this.acctRef, 'tradingwidgetsparams').subscribe(
                resp => {
                    console.log('Retrived common REST TRading widgets param : ', resp.response);
                    if (resp.response) {
                        resp.response.pendingOrderUrl = this.nxiRestService.serviceUrl + resp.response.pendingOrderUrl;
                        resp.response.openOrderUrl = this.nxiRestService.serviceUrl + resp.response.openOrderUrl;
                        resp.response.recentOrderUrl = this.nxiRestService.serviceUrl + resp.response.recentOrderUrl;                        
                        resp.response.modApiUrl = this.appSettings.ibdConfigMap.modApiUrl;
                        this.renderDojoWidget(resp.response);
                    }
                }
            );
        }
    }
}
